import { RouteService } from '../../services/route.service';
import { Component, OnInit, Injector } from '@angular/core';
import { MerchantsComponent } from '../merchants/merchants.component';
import { NoteService } from 'src/app/services/note.service';
import { Note } from 'src/app/Note';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { FormUtils } from 'src/app/FormUtils';

export interface NoteCategory {
  name: string;
  type: string;
}

@Component({
  selector: 'app-merchant-notes',
  templateUrl: './merchant-notes.component.html',
  styleUrls: ['./merchant-notes.component.css']
})
export class MerchantNotesComponent extends MerchantsComponent
  implements OnInit {
  payrollAccount: '';
  actionStatus = '';
  noteTypes = [];
  note: Note;
  notes: Note[] = [];
  categories: any[] = [];
  $state: any = null;
  dataLoading = false;
  savingNote = false;
  notesForm: UntypedFormGroup;
  inputText = '';

  constructor(
    injector: Injector,
    private noteService: NoteService,
    private formUtils: FormUtils) {
    super(injector);
  }

  ngOnInit() {

    this.dataLoading = true;
    this.merchantAccountInfoSet.subscribe(() => {
      this.payrollAccount = this.merchantAccountInfo.cardList[0].payrollAccount;
      this.getNotes();
    });

    this.noteService.getNoteCategory().subscribe(
      (data: NoteCategory[]) => {
        const catArr = new Array();
        const keys = new Array();
        const jsonArr = [];
        for (let i = 0, j = 0; i < data.length; i++) {
          if (catArr[data[i].name]) {
            catArr[data[i].name] = catArr[data[i].name] + ',' + data[i].type;
          } else {
            catArr[data[i].name] = data[i].type;
            keys[j++] = data[i].name;
          }
        }
        for (let i = 0; i < keys.length; i++) {
          jsonArr.push({
            name: keys[i],
            types: catArr[keys[i]].split(',')
          });
        }
        this.categories = jsonArr;
      },
      error => {
        this.messageService.error(error.error);
      }
    );
    this.initForm();
  }

  initForm() {
    this.notesForm = new UntypedFormGroup({
      'noteCat': new UntypedFormControl('', [Validators.required]),
      'noteType': new UntypedFormControl('', [Validators.required]),
      'noteCase': new UntypedFormControl(''),
      'noteDetail': new UntypedFormControl('', [Validators.required])
    });
  }

  change() {
    const noteCat = this.notesForm.value['noteCat'];
    const cat = this.categories;
    for (let i = 0; i < cat.length; i++) {
      if (noteCat === cat[i].name) {
        this.noteTypes = cat[i].types;
        break;
      }
    }
  }

  hasEntitlement(entitlement: string) {
    return this.entitlementService.hasEntitlement(entitlement);
  }

  getNotes() {
    this.noteService.getNotes(this.payrollAccount).subscribe(notes => {
      this.notes = notes;
      this.dataLoading = false;
    });
  }

  textInput(input: string) {
    this.inputText = input;
  }

  saveNote() {
    this.formUtils.markFormFieldsAsTouched(this.notesForm);
    if (!this.notesForm.valid) {
      return false;
    }
    this.savingNote = true;
    const params = {
      'payrollAccount': this.payrollAccount,
      'note_cat': this.notesForm.value['noteCat'],
      'note_type': this.notesForm.value['noteType'],
      'note_case': this.notesForm.value['noteCase'] ? this.notesForm.value['noteCase'] : '',
      'note_detail': this.notesForm.value['noteDetail']
    };
    this.noteService.sendNote(params)
      .subscribe(
        (data: Note[]) => {
          this.messageService.success('Saved Successfully');
          this.savingNote = false;
          this.notes = data;
          this.initForm();
          this.resetButton();
        },
        error => {
          this.savingNote = false;
          this.messageService.error(error.error);
          this.resetButton();
        }
      );
  }

  resetButton() {
    const button = document.getElementById('submitButton');
    button.blur();
  }
}
